import styled from '@emotion/styled';
import React from 'react';

interface DisclaimerProps {
  site: string; // 'stripe_inc' | 'stripe_ou';
}

const COMPANY_NAMES = {
  stripe_ou: 'Toggl OÜ',
  stripe_inc: 'Toggl Inc.',
};

export function Disclaimer({ site }: DisclaimerProps) {
  const companyName = COMPANY_NAMES[site] || 'Toggl';

  return (
    <DisclaimerContainer>
      By providing your card information, you consent that {companyName} may
      charge your card for future payments in a recurring manner in accordance
      with the{' '}
      <a
        href="https://toggl.com/legal/hire/terms"
        target="_blank"
        rel="noreferrer noopener"
      >
        Terms of Service
      </a>
      . Please note that some of the payments may not be refundable.{' '}
      {companyName} will notify you before the renewal of your Service Plan,
      allowing you to cancel in a timely manner.
    </DisclaimerContainer>
  );
}

const DisclaimerContainer = styled.div`
  margin-top: 10px;
  font-size: 10px;
  color: ${(props) => props.theme.typography.colorSecondary};
  text-align: justify;

  a {
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
  }
`;
